$(document).ready(function () {

    for (var i = 0; i < document.links.length; i++) {
        if (document.links[i].href === document.URL || document.URL.includes(document.links[i].href)) {
            document.links[i].className += ' selected';
        }
    }

});
